module.exports = __webpack_public_path__ + "ui-static/img/couldnt-find_dark.236f7197.svg";